var map = {
	"./CanvasClear": 4620,
	"./CanvasClear.ts": 4620,
	"./CanvasMove": 5660,
	"./CanvasMove.ts": 5660,
	"./CommandAbstract": 602,
	"./CommandAbstract.ts": 602,
	"./ComponentDelete": 1273,
	"./ComponentDelete.ts": 1273,
	"./ComponentDrag": 8624,
	"./ComponentDrag.ts": 8624,
	"./ComponentEnter": 1638,
	"./ComponentEnter.ts": 1638,
	"./ComponentExit": 4610,
	"./ComponentExit.ts": 4610,
	"./ComponentNext": 8043,
	"./ComponentNext.ts": 8043,
	"./ComponentPrev": 4751,
	"./ComponentPrev.ts": 4751,
	"./ComponentStyleClear": 4648,
	"./ComponentStyleClear.ts": 4648,
	"./CopyComponent": 7693,
	"./CopyComponent.ts": 7693,
	"./ExportTemplate": 6973,
	"./ExportTemplate.ts": 6973,
	"./Fullscreen": 4428,
	"./Fullscreen.ts": 4428,
	"./MoveComponent": 229,
	"./MoveComponent.ts": 229,
	"./OpenAssets": 9660,
	"./OpenAssets.ts": 9660,
	"./OpenBlocks": 4331,
	"./OpenBlocks.ts": 4331,
	"./OpenLayers": 2103,
	"./OpenLayers.ts": 2103,
	"./OpenStyleManager": 2529,
	"./OpenStyleManager.ts": 2529,
	"./OpenTraitManager": 6190,
	"./OpenTraitManager.ts": 6190,
	"./PasteComponent": 5203,
	"./PasteComponent.ts": 5203,
	"./Preview": 8025,
	"./Preview.ts": 8025,
	"./Resize": 3941,
	"./Resize.ts": 3941,
	"./SelectComponent": 1772,
	"./SelectComponent.ts": 1772,
	"./SelectPosition": 8046,
	"./SelectPosition.ts": 8046,
	"./ShowOffset": 4851,
	"./ShowOffset.ts": 4851,
	"./SwitchVisibility": 501,
	"./SwitchVisibility.ts": 501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;